import React from 'react'
import PharmacyHeading from '../PharmacyHeading'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import img1 from '../../../assets/img/pharmacy/partner/partner_1.png'
import img2 from '../../../assets/img/pharmacy/partner/partner_2.png'
import img3 from '../../../assets/img/pharmacy/partner/partner_3.png'
import img4 from '../../../assets/img/pharmacy/partner/partner_4.png'
import img5 from '../../../assets/img/pharmacy/partner/partner_5.png'
import img6 from '../../../assets/img/pharmacy/partner/partner_1.png'
import img7 from '../../../assets/img/pharmacy/partner/partner_3.png'
import reviewbg from '../../../assets/img/pharmacy/partner/reviewbg.png'
import { RatingStar } from "rating-star";
import './style.css'
import Heading from '../../Fashion/Heading';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const TopBrand = (props) => {
    const { t, i18n } = useTranslation();
    let settings = {
        arrows: false,
        dots: true,
        margin: 60,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
        },
        ]
    };
    return (
        <>
            <section id="pharmacy_top_brand" className="ptb-100 slider_button_left_right">
                <div className="container">
                    {/* <PharmacyHeading heading="Our Partners" /> */}
                    <Heading heading={t("testimonials")} para={t("testimonialssubheading")}/>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="pharmacy_top_brand_slider text-center">
                                <Slider {...settings}>
                            
                  {props.testimonials.map((data, index) => (
                    <div className='text-center' key={index} >
                    <div className="reviewbg">
                        <img src={process.env.REACT_APP_IMG_URL + data.image}  className="rounded-cirk" />

                    </div>
                    <div className='w-75 mx-auto'>
                        <div >
                            <h3>{data?.title?.[i18n.language]}</h3>
                            <p className='text-warn'>{data?.location?.[i18n.language]}</p>
                            <p className='text-justify'>“{data?.description?.[i18n.language]}”</p>
                        </div>

                        <div>

                            <p className='text-warn small float-left'>{moment(data.createdDate).format("ll")}</p>
                            <div className='float-right'>
                                <RatingStar maxScore={5} id="rating-star-compare" rating={data.rating} />
                            </div>

                        </div>
                    </div>

                </div>
                  ))}
               
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TopBrand